import Portfolio from "../../../commonComponents/portfolio";
import VideoModal from "../../../commonComponents/modals/VideoModal";

const PortfolioVideoModalContainer = () => {
  return (
    <>
      <Portfolio sectionClass="portfolio-video" type="video" gridSize={3} carShow={9} />
      <VideoModal />
    </>
  );
};

export default PortfolioVideoModalContainer;
